import {tableHtmlCreate} from "./printDomCreate";
import download from "./exclHandler";

/**
 * 列表 PDF（A4） 打印
 * 新建标签页
 * @params: Object {headerList<Array>; printData<Array>; svgCode String; customEl String|DOM}
 * headerList <headerInfo>: headerInfo 表头 与 antDesign table 的 columns 对应
 * printData <printInfo>: printInfo 列表 与 antDesign table 的 dataSource 对应
 * **/
export const pagePrint = function ({
                                       title = '打印列表',
                                       headerList = [],
                                       printData = [],
                                       scanCode = null,
                                       customEl = null
                                   }) {
    /**
     * 表头
     * headerList Array<Object>: [{title:String, dataIndex: String}] 可以直接使用 antDesign table 的 columns
     * title String：每列的中文名称
     * dataIndex String: 每列对应用的取值 key
     * **/


    /**
     * 列表内容
     * printData Array<printInfo> 可以直接使用 antDesign table 的 dataSource
     * printInfo object :每一行打印详情
     * **/

    /**
     * 条形码区
     * scanCode
     *
     */

    /**
     * customEl Object：{el: String |DOM, style: style}
     * 自定义 非表格内容
     * el String|DOM: html
     * style String: style
     */

    let tableHeader = headerList.map(item => {
        return item.title
    })
    let tableContent = printData.map(item => {
        return headerList.map(temp => {
            return item[temp.dataIndex]
        })
    })
    // console.log(tableHtmlCreate(tableHeader, tableContent))
    /**
     * 最终生成的数据是二维数组，用于 DOM 生成
     * **/
    setTimeout(() => {
        // 写入 DOM
        const newPage = window.open('', '');
        tableHtmlCreate({
            newPage,
            title,
            tableHeader,
            tableContent,
            scanCode,
            customEl
        });
        newPage.focus()
        newPage.window.print()
        return false;
    }, 100)
}


// import { login } from '@api/login'
// import { getAction } from '@/api/manage'
/**
 * 热敏纸打印
 * @params: printData<array>
 * printData[*].pkgCode
 * printData[*].planType
 * printData[*].sku
 * printData[*].mash
 * **/
export const callPrinter = function (printData) {


        // TODO 打印热敏纸 逻辑暂未完成
    let _printData = printData
    // // planType === 1 时, 打印需要添加 nameEN 和 nameCN
    // // 因为打印的数据为数组，而且数组中的每一项的 planType 都是相同的
    // if (printData[0].planType === 1) {
    //     const res = await getAction('/batch/pkg/qualityRequire?pkgCode=' + printData[0].pkgCode)
    //     try {
    //         const { nameCN = '', nameEN = '' } = res.data
    //         _printData = printData.map(item => Object.assign({ nameEN, nameCN }, item))
    //     } catch (e) {
    //         console.log('printFn-err', JSON.stringify(e))
    //     }
    // }
    // console.log('printData', _printData)
    let ws = new WebSocket('ws://localhost:8888/printer/GPrinter')
    ws.addEventListener('open', event => {
        // console.log(event)
        ws.send(JSON.stringify(_printData))
        ws.close()
    })
}

/**
 * excel 导出
 * 新建标签页
 * @params: Object {headers <Array>; printData <Array>; fileName String;}
 * headers <headerInfo>: headerInfo ；表头 与 antDesign table 的 columns 对应
 * contents <content>: content : 每行内容 与 antDesign table 的 dataSource 对应
 * fileName String: 列表名
 * **/
export const excelExport = function ({headers = [], contents = [], fileName = '表格'}) {



    /**
     * 表头
     * headers Array<Object>: [{title:String, dataIndex: String}] 表头内容部分 可以直接使用 antDesign table 的 columns
     * title String：每列的中文名称
     * dataIndex String: 每列对应用的取值 key
     * **/

        // 使用 headers download 函数需要的表头格式
    const _headers = headers.reduce((pre, item) => {
            const obj = {
                [item.title]: item.title
            }
            pre = Object.assign(pre, obj)
            // console.log(pre)
            return pre
        }, {})
    /**
     * 列表内容
     * contents Array<content>: 列表内容部分 可以直接使用 antDesign table 的 dataSource
     * content Object: 每一行打印详情
     * **/
        // 使用 contents download 函数需要的内容格式
    const _contents = contents.map(item => {
            return headers.reduce((pre, temp) => {
                const obj = {
                    [temp.title]: item[temp.dataIndex] === undefined ? '' : item[temp.dataIndex]
                }
                pre = Object.assign(pre, obj)
                // console.log(pre)
                return pre
            }, {})
        })
    /**
     * 表头
     * fileName String: 列表名
     * 无需加 .xlsx 后缀
     * **/
    download([_headers, ..._contents], fileName)
}







/***
 * 语音播报
 * 使用 IE ActiveXObject API 以及 H5 SpeechSynthesisUtterance API 实现
 * */
export const audioPay = function (msg) {
    let isIe = !!window.ActiveXObject || "ActiveXObject " in window
    if(isIe){
        let voiceObj = new ActiveXObject("Sapi.SpVoice")
        voiceObj.Rate = -1 // 语速
        voiceObj.Volume = 60 // 音量
        voiceObj.Speak(msg,1)
    }else{
        let speakMsg = new SpeechSynthesisUtterance(msg)
        speakMsg.rate = 1 // 语速
        speakMsg.pitch = 1.5 // 音量
        window.speechSynthesis.speak(speakMsg)
    }
}
